import Card from 'components/card/Card';
import CampaignsTopSection from './components/CampaignsTopSection';
import CampaignsTable from './components/CampaignsTable';
import { CampaignsProvider } from './context/CampaignsContext';
import CreateEditCampaignModal from './components/CreateEditCampaignModal';

const MessageCampaigns = () => {
  return (
    <CampaignsProvider>
      <Card direction="column" w="100%" px="0px" overflowX={{ sm: 'scroll', lg: 'hidden' }}>
        <CampaignsTopSection />
        <CampaignsTable />
      </Card>
      <CreateEditCampaignModal />
    </CampaignsProvider>
  );
};

export default MessageCampaigns;
